/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types'; 
import { Button, Modal, Grid, Table} from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';

const VAZIO = '';
const linhasPorPagina = 13;

class ModalExibirRemuneracoesPreenchidas extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    touched: false,
  });

  modalFooter = () => (
    <React.Fragment>
      <Button
        className="reajustaDireitaBotao"
        title='fechar'
        onClick={this.handleClose}
        hint='fechar'
      />
    </React.Fragment>
  )

  addMesLabel = tipo => (
    listUtils.getObject(listUtils.meses, tipo).labelCompleto
  )

  addRemuneracaoLabel = valor => {
    let retorno = valor;
    if (retorno) {
      retorno = retorno.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 })
    }
    return retorno;
  }

  montaColunas = () => {
    return [
      {
        id: 'ano',
        label: 'Ano',
      },
      {
        id: 'mes',
        label: 'Mês',
        dataFormat: this.addMesLabel,
      },
      {
        id: 'siglaMoeda',
        label: 'Moeda',
      },
      {
        id: 'valor',
        label: 'Valor',
        dataFormat: this.addRemuneracaoLabel,
      },
    ];
  }

  options = {
    noDataText: 'Não existem remunerações',
    hideSizePerPage: true,
    sizePerPage: linhasPorPagina,
  }

  modalContent = () => (
    <React.Fragment>
      <div style={{ height: '470px', 'overflow-y': 'auto', 'overflow-x': 'auto'}}>
        <Grid cols="12 12 12 12">
          <Table
            bordered
            data={this.props.ordenarCompetenciasRemuneracao(this.props.remuneracoes)}
            options={this.options}
            listaTableHeader={this.montaColunas()}
            pagination
            scrollTop="Top"
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.exibirModalRemuneracoesPreenchidas);
  }

  render() {
    return (
      <Modal
        {...this.props}
        backdrop="static"
        keyboard={false}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModalExibirModalRemuneracoesPreenchidas}
        title="remunerações preenchidas"
        hint={VAZIO}
      />
    );
  }
}

ModalExibirRemuneracoesPreenchidas.propTypes = {
  exibirModalRemuneracoesPreenchidas: PropTypes.func,
  showModalExibirModalRemuneracoesPreenchidas: PropTypes.func,
  remuneracoes: PropTypes.arrayOf({
    mes: PropTypes.string,
    ano: PropTypes.string,
    tipoMoeda: PropTypes.string,
    siglaMoeda: PropTypes.string,
    valor: PropTypes.string,
  }).isRequired,
  ordenarCompetenciasRemuneracao: PropTypes.func,
}.isRequired;

export default ModalExibirRemuneracoesPreenchidas;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/ModalExibirRemuneracoesPreenchidas.jsx